module.exports = __webpack_public_path__ + "assets/img/serve2.f7db8ef9.png";